export function isInTimeIntervalToNow(
  time: number,
  intervalTimeInMillisecond: number
): boolean {
  return time * 1000 + intervalTimeInMillisecond >= Date.now();
}
